import React from "react";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { Grid, Typography, Button } from "@mui/material";
import dataProvider from "server/dataProvider";
import { useNotify } from "react-admin";
import { accountRequests } from "api/accountApi";

const DEFAULT_SUCCESS_MESSAGE = "Паролата беше успешно сменена и изпратена на имейла на потребителя.";
const DEFAULT_DESCRIPTION = "Ще бъде генерирана нова парола и изпратена на имейла на потребителя.";

// Defaults reset the platform (account) password by userId. Pass `request` (+ texts) to reuse the same
// confirm flow for another password, e.g. the student's Google Workspace one.
// `variant` / `size` follow EditEmailDialog: pass variant="contained" size="small" to match the buttons
// next to it; the defaults (text, medium) keep the existing usages unchanged.
const PasswordResetAction = ({
  userId,
  label = "Смяна на парола",
  request,
  successMessage = DEFAULT_SUCCESS_MESSAGE,
  description = DEFAULT_DESCRIPTION,
  variant = null,
  size = "medium",
}) => {
  const notify = useNotify();

  const handleConfirm = async () => {
    await dataProvider.customRequest(request ?? accountRequests.changeUserPassword(userId), {}, "PUT");
    notify(successMessage, { type: "success" });
  };

  return (
    <ConfirmModal
      titleContent={label}
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          variant={variant || "text"}
          size={size}
          color="primary"
          startIcon={<VpnKeyIcon />}
        >
          {label}
        </Button>
      }
    >
      <Grid sx={{ py: 2 }}>
        <Typography>{description}</Typography>
        <br />
        <Typography>Потвърждавате ли действията?</Typography>
      </Grid>
    </ConfirmModal>
  );
};

export default PasswordResetAction;
